(function () {
  var form = document.querySelector('[data-ilmas-atc-form]');
  if (!form) return;
  var root = document.querySelector('[data-ilmas-pdp]');
  var idInput = form.querySelector('[data-ilmas-atc-id]');
  var qtyInput = form.querySelector('input[name="quantity"]');
  var btn = form.querySelector('[data-ilmas-atc-btn]');
  var btnHtml = btn ? btn.innerHTML : '';
  var data = null;
  var jsonEl = root && root.querySelector('[data-ilmas-product-json]');
  try { data = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { data = null; }
  var sels = root ? Array.prototype.slice.call(root.querySelectorAll('[data-ilmas-option]')) : [];

  function matchOpt(v, sel) {
    var idx = parseInt(sel.getAttribute('data-option-index'), 10) || 0;
    return String(v['option' + (idx + 1)] || '') === String(sel.value);
  }

  function selectedVariant() {
    if (!data || !data.variants) return null;
    if (!sels.length) return data.variants[0] || null;
    return data.variants.find(function (v) {
      return sels.every(matchOpt.bind(null, v));
    }) || null;
  }

  function syncVariant() {
    var v = selectedVariant();
    if (!v || !idInput || !btn) return;
    idInput.value = v.id;
    var ok = v.available !== false && v.price > 0;
    btn.disabled = !ok;
    if (ok) btn.innerHTML = btnHtml;
    else btn.textContent = 'Solo con presupuesto';
  }

  function onQtyClick(e) {
    var step = parseInt(e.currentTarget.getAttribute('data-ilmas-qty'), 10) || 0;
    var val = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = Math.max(1, val + step);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-ilmas-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function afterAdd() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); });
    btn.textContent = 'Añadido ✓';
    window.setTimeout(restoreBtn, 2000);
  }

  function restoreBtn() {
    btn.innerHTML = btnHtml;
    btn.disabled = false;
  }

  function onError() {
    restoreBtn();
    form.submit();
  }

  function onSubmit(e) {
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    fetch(form.action + '.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('atc'); return r.json(); })
      .then(afterAdd)
      .catch(onError);
  }

  form.querySelectorAll('[data-ilmas-qty]').forEach(function (b) {
    b.addEventListener('click', onQtyClick);
  });
  sels.forEach(function (sel) { sel.addEventListener('change', syncVariant); });
  form.addEventListener('submit', onSubmit);
  syncVariant();
})();
